import { tv, type VariantProps } from "tailwind-variants";

export const switchVariant = tv({
  slots: {
    base: ["flex", "items-center", "gap-2", "group", "py-2"],
    label: ["text-text-neutral-soft"],
    root: [
      "relative",
      "w-11",
      "h-6.5",
      "bg-surface-neutral-strong",
      "rounded-full",
      "data-[state=checked]:bg-background-brand-default",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "focus:outline-2",
      "focus:outline-black",
      "focus:ring-4",
      "focus:ring-background-brand-default",
      "group-hover:opacity-70",
    ],
    thumb: [
      "block",
      "w-5.5",
      "h-5.5",
      "bg-surface-neutral-soft",
      "rounded-full",
      "shadow-sm",
      "transition-transform",
      "transform",
      "translate-x-0.5",
      "data-[state=checked]:translate-x-5",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "group-hover:opacity-70",
    ],
  },
  variants: {
    disabled: {
      true: {
        root: ["opacity-30"],
        thumb: ["opacity-30"],
      },
      false: {},
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export type SwitchVariantProps = VariantProps<typeof switchVariant>;
export type SwitchReturnVariantProps = ReturnType<typeof switchVariant>;
